import { app as api } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
import { enableHidingFinishedBills } from '../../../lib/featbit';
var getUserId = function () {
    var _a, _b, _c, _d, _e;
    try {
        return ((_a = Fetch === null || Fetch === void 0 ? void 0 : Fetch.staffSetting) === null || _a === void 0 ? void 0 : _a.id) || (Fetch === null || Fetch === void 0 ? void 0 : Fetch.staffId) || ((_d = (_c = (_b = api.getState('@common')) === null || _b === void 0 ? void 0 : _b.userinfo) === null || _c === void 0 ? void 0 : _c.staff) === null || _d === void 0 ? void 0 : _d.id);
    }
    catch (error) {
        return ((_e = Fetch === null || Fetch === void 0 ? void 0 : Fetch.staffSetting) === null || _e === void 0 ? void 0 : _e.id) || (Fetch === null || Fetch === void 0 ? void 0 : Fetch.staffId);
    }
};
export var getSortConfig = function () {
    var userId = getUserId();
    var sortKey = "Hose-mybill-current-sort-option_" + userId;
    try {
        var cache = JSON.parse(localStorage.getItem(sortKey));
        return cache || { value: 'form.submitDate', order: 'desc' };
    }
    catch (error) {
        return { value: 'form.submitDate', order: 'desc' };
    }
};
export var setSortConfig = function (sortValue) {
    var userId = getUserId();
    var sortKey = "Hose-mybill-current-sort-option_" + userId;
    localStorage.setItem(sortKey, JSON.stringify(sortValue));
};
export var getRawFilterConfig = function () {
    var userId = getUserId();
    var filterKey = userId + "-filter";
    try {
        var cachedFilter = localStorage.getItem(filterKey);
        if (cachedFilter) {
            return JSON.parse(cachedFilter);
        }
        return null;
    }
    catch (error) {
        console.warn('Failed to parse cached filter:', error);
        return null;
    }
};
export var getFilterConfig = function () {
    var parsedFilter = getRawFilterConfig();
    if (parsedFilter) {
        return parsedFilter.map(function (el) {
            var _a;
            return ({
                key: el.type,
                value: (_a = el === null || el === void 0 ? void 0 : el.children) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.type; })
            });
        });
    }
    return null;
};
export var setFilterConfig = function (filterData) {
    var userId = getUserId();
    var filterKey = userId + "-filter";
    localStorage.setItem(filterKey, JSON.stringify(filterData));
};
export var clearFilterConfig = function () {
    var userId = getUserId();
    var filterKey = userId + "-filter";
    localStorage.removeItem(filterKey);
};
export var getRawMultiSelectFilterConfig = function () {
    var userId = getUserId();
    var multiSelectKey = userId + "-multiselect-filter";
    try {
        var cachedMultiSelectFilter = localStorage.getItem(multiSelectKey);
        if (cachedMultiSelectFilter) {
            return JSON.parse(cachedMultiSelectFilter);
        }
        return null;
    }
    catch (error) {
        console.warn('Failed to parse cached multi-select filter:', error);
        return null;
    }
};
var getValueByFilterType = function (filterState, type) {
    var value = filterState[type];
    var isAllOption = value.find(function (opt) { return opt.isSelected && (opt.type === 'all' || opt.type === 'ALL_DELEGATE'); });
    if (isAllOption) {
        return [isAllOption.type];
    }
    return value
        .filter(function (opt) { return opt.isSelected && opt.type !== 'all' && opt.type !== 'ALL_DELEGATE'; })
        .map(function (opt) { return opt.type; });
};
var getStateValue = function (_multiSelectFilterState) {
    return Object.keys(_multiSelectFilterState).map(function (filterType) { return ({
        key: filterType,
        value: getValueByFilterType(_multiSelectFilterState, filterType)
    }); });
};
export var getMultiSelectFilterConfig = function () {
    var parsedFilter = getRawMultiSelectFilterConfig();
    if (parsedFilter) {
        return getStateValue(parsedFilter);
    }
    return null;
};
export var setMultiSelectFilterConfig = function (filterState) {
    var userId = getUserId();
    var multiSelectKey = userId + "-multiselect-filter";
    localStorage.setItem(multiSelectKey, JSON.stringify(filterState));
};
export var clearMultiSelectFilterConfig = function () {
    var userId = getUserId();
    var multiSelectKey = userId + "-multiselect-filter";
    localStorage.removeItem(multiSelectKey);
};
export var getBillFilterConfig = function () {
    var currentSortValue = getSortConfig();
    var filterTypes = null;
    if (enableHidingFinishedBills()) {
        filterTypes = getMultiSelectFilterConfig();
    }
    else {
        filterTypes = getFilterConfig();
    }
    return {
        filterValue: 'all',
        searchValue: '',
        filterTypes: filterTypes,
        currentSortValue: currentSortValue
    };
};
export var sortLocalStorage = {
    get key() {
        var userId = getUserId();
        return "Hose-mybill-current-sort-option_" + userId;
    },
    get: getSortConfig,
    set: setSortConfig
};
